import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_GET',
  GET_SUCCESS: 'TEACHER_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_GET_FAILURE',
};

export const get = actions.get(teacherId => `${BASE_URL}/teachers/${teacherId}/detail/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});
